import { D_CLEAR_APPROVAL_REJECTION_SUCCESS, D_CLEAR_FORM_DATA, D_SET_APPROVAL_REJECTION_SUCCESS, D_SET_FORM_DATA } from "../types";

const initialState = {
    success: null,
}

export const dynamicFormReducer = (state = initialState, action: { type: string, payload: any }) => {
    switch (action.type) {
        case D_SET_FORM_DATA:
            return { ...state, ...action.payload }
        case D_CLEAR_FORM_DATA:
            return { ...initialState }
        case D_SET_APPROVAL_REJECTION_SUCCESS:
            return { ...state, success: action.payload }
        case D_CLEAR_APPROVAL_REJECTION_SUCCESS:
            return { ...state, success: null }
        default:
            return state;
    }
}